import { FaRightFromBracket } from "react-icons/fa6";
import { modalAnim } from "../../components/modal_anim";
import { ModalOverlay } from "./modal_overlay";
import { modalBoxStyle } from "../../components/modal_box_style";
import { useState } from "react";
import { WaDeviceService } from "../../../../../../services/WaDeviceService";

export const WaLogoutModal = ({ dataDevice, openModal, setOpenModal, refreshData }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirmLogout = async () => {
        const payload = {
            device: dataDevice?.number,
        };

        try {
            const response = await WaDeviceService.logout({ data: payload });

            if (response.data.success || response.status === 200) {
                alert(response.data.message || "Device berhasil logout!");
                setOpenModal(false);
                refreshData();
            } else {
                alert(response.data.message || "Gagal logout device.");
            }
        } catch (error) {
            console.error("Error logout device:", error);
            let errorMessage = "Terjadi kesalahan pada server.";

            if (error.response && error.response.data && error.response.data.message) {
                errorMessage = error.response.data.message;
            }

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (!openModal) return null;

    return (
        <ModalOverlay onClose={() => !loading && setOpenModal(false)}>
            <style>{modalAnim}</style>
            <div
                className="relative w-full max-w-xs rounded-2xl p-6 shadow-2xl border"
                style={{
                    ...modalBoxStyle,
                    animation: "modalIn 0.25s ease-out",
                }}
            >
                <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-orange-500/8 border border-orange-500/15 flex items-center justify-center">
                        <FaRightFromBracket className="text-orange-400 text-2xl" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-100 mb-2">
                        Logout Device?
                    </h3>
                    <p className="text-sm text-slate-400 mb-6 leading-relaxed">
                        Putuskan koneksi{" "}
                        <span className="text-white font-semibold">
                            {dataDevice?.number}
                        </span>{" "}
                        dari server?
                    </p>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => !loading && setOpenModal(false)}
                            disabled={loading}
                            className="flex-1 px-4 py-2.5 rounded-xl text-xs font-semibold transition-all bg-slate-800 text-slate-300 hover:bg-slate-700 border border-slate-700 disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            Batal
                        </button>

                        <button
                            onClick={handleConfirmLogout}
                            disabled={loading}
                            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-xs font-semibold transition-all bg-orange-600 text-white hover:bg-orange-500 disabled:opacity-40 disabled:cursor-not-allowed shadow-lg shadow-orange-600/20"
                        >
                            {loading ? (
                                <>
                                    <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                    Memutus...
                                </>
                            ) : (
                                "Ya, Logout"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </ModalOverlay>
    );
};